var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-main"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"title"},[_vm._v("当前："+_vm._s(_vm.title))]),_vm._t("default"),_vm._t("left")],2),_c('div',{staticClass:"right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }